// Project Creation
export const CREATE_PROJECT_REQUEST = "CREATE_PROJECT_REQUEST";
export const CREATE_PROJECT_SUCCESS = "CREATE_PROJECT_SUCCESS";
export const CREATE_PROJECT_FAILURE = "CREATE_PROJECT_FAILURE";

// Get Project Details
export const GET_PROJECT_REQUEST = "GET_PROJECT_REQUEST";
export const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS";
export const GET_PROJECT_FAILURE = "GET_PROJECT_FAILURE";

// Update Project
export const UPDATE_PROJECT_REQUEST = "UPDATE_PROJECT_REQUEST";
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS";
export const UPDATE_PROJECT_FAILURE = "UPDATE_PROJECT_FAILURE";

// Reset State
export const RESET_PROJECT_STATE = "RESET_PROJECT_STATE";

//get current project
export const GET_CURRENT_PROJECT = "GET_CURRENT_PROJECT";

// Project Loader Start
export const PROJECT_LOADER_START = "PROJECT_LOADER_START";
export const PROJECT_LOADER_STOP = "PROJECT_LOADER_STOP";
